import axios from 'axios';
import axiosRetry from 'axios-retry';
import * as actions from './actionsTypes';
import errorManage from '../errorManage';
import messages from '../messages';
import toastr from 'toastr';
import areasServices from './areas.services';
const client = axios.create({ baseURL: process.env.REACT_APP_URL });
axiosRetry(client, { retries: 5, retryDelay: axiosRetry.exponentialDelay });

export const resetAreas = () => async (dispatch, getState) => {
  dispatch({
    type: actions.FORM_FAIL,
    payload: "",
  });
}

export const getAreas = (data, iType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_AREAS,
      payload: true
    });
    // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    // const resp = await client.get(iType === 1 ? '/api/app/Formal_unidad/' : '/api/app/Funcional_unidad/', {
    //   headers: {
    //     'Content-Type': 'application/json',
    //     'Authorization': `Token ${token}`
    //   },
    //   params: data
    // });
    const resp = await areasServices.getAreas(data, iType);
    dispatch({
      type: actions.GET_AREAS,
      payload: {
        areas: resp.data.data,
        areasLength: resp.data.count
      }
    });
    dispatch({
      type: actions.AREAS_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if(Array.isArray(ex.response.data)){
              ex.response.data.forEach(item => {
                toastr.error(item);
              });
            }else{
              message = ex.response.data;
            }
            break;
          case 404:
            if(ex.response.data && ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else{
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      }else{
        message = messages.networkError;
      }
    }else{
      message = messages.applicationError
    }
    dispatch({
      type: actions.AREAS_FAIL,
      payload: message,
    });
  }finally{
    dispatch({
      type: actions.LOADING_AREAS,
      payload: false
    });
  }
}

export const getAreasJerarquia = (data, iType, isModalSearch) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_AREAS,
      payload: true
    });
    // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    // const resp = await client.get(isModalSearch ? "/api/app/Funcional_Unidad_Organizativa_evaluacion/" :iType === 1 ? '/api/app/Formal_unidadjerarquia/' : '/api/app/Funcional_unidadjerarquia/', {
    //   headers: {
    //     'Content-Type': 'application/json',
    //     'Authorization': `Token ${token}`
    //   },
    //   params: data
    // });
    const resp = await areasServices.getAreasJerarquia(data, iType, isModalSearch);
    dispatch({
      type: actions.GET_AREAS,
      payload: {
        areas: resp.data.data,
        areasLength: resp.data.count
      }
    });
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.LOADING_AREAS,
      payload: false
    });
  }
}

export const saveAreas = (data, iType, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_AREAS,
      payload: true
    });
    // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    // const resp = await client.post(iType === 1 ? '/api/app/Formal_unidad/' : '/api/app/Funcional_unidad/', data, {
    //   headers: {
    //     'Content-Type': 'application/json',
    //     'Authorization': `Token ${token}`
    //   }});
    const resp = await areasServices.saveAreas(data, iType);
    const { areas, areasLength } = getState().areas;
    const aAreas = [...areas, resp.data];
    dispatch({
      type: actions.GET_AREAS,
      payload: {
        areas: aAreas,
        areasLength: areasLength + 1
      }
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    setShowModal(false);
    toastr.success(messages.successMessage);
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if(Array.isArray(ex.response.data)){
              ex.response.data.forEach(item => {
                toastr.error(item);
              });
            }else{
              message = ex.response.data;
            }
            break;
          case 404:
            if(ex.response.data && ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else{
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      }else{
        message = messages.networkError;
      }
    }else{
      message = messages.applicationError
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  }finally{
    dispatch({
      type: actions.SAVE_LOADING_AREAS,
      payload: false
    });
  }
}

export const editAreas = (data, id, index, iType, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_AREAS,
      payload: true
    });
    // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    // const resp = await client.put(iType === 1 ? `/api/app/Formal_unidad/${id}/` : `/api/app/Funcional_unidad/${id}/`, data, {
    // headers: {
    //   'Content-Type': 'application/json',
    //   'Authorization': `Token ${token}`
    // }});
    const resp = await areasServices.editAreas(id, data, iType);
    const { areas, areasLength } = getState().areas;
    areas[index] = resp.data;
    //const aJobPositions = [...jobPositions, resp.data];
    dispatch({
      type: actions.GET_AREAS,
      payload: {
        areas: areas,
        areasLength: areasLength
      }
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    setShowModal(false);
    toastr.success(messages.successMessage);
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if(Array.isArray(ex.response.data)){
              ex.response.data.forEach(item => {
                toastr.error(item);
              });
            }else{
              message = ex.response.data;
            }
            break;
          case 404:
            if(ex.response.data && ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else{
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      }else{
        message = messages.networkError;
      }
    }else{
      message = messages.applicationError
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  }finally{
    dispatch({
      type: actions.SAVE_LOADING_AREAS,
      payload: false
    });
  }
}

export const deleteAreas = (id, index, iType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_AREAS,
      payload: true
    });
    // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    // await client.delete(iType === 1 ? `/api/app/Formal_unidad/${id}/` : `/api/app/Funcional_unidad/${id}/`, {
    // headers: {
    //   'Content-Type': 'application/json',
    //   'Authorization': `Token ${token}`
    // }});
    await areasServices.deleteAreas(id, iType);
    const { areas, areasLength } = getState().areas;
    areas.splice(index, 1);
    //const aJobPositions = [...jobPositions, resp.data];
    dispatch({
      type: actions.GET_AREAS,
      payload: {
        areas: areas,
        areasLength: areasLength -1
      }
    });
    dispatch({
      type: actions.AREAS_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if(Array.isArray(ex.response.data)){
              ex.response.data.forEach(item => {
                toastr.error(item);
              });
            }else{
              message = ex.response.data;
            }
            break;
          case 404:
            if(ex.response.data && ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else{
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      }else{
        message = messages.networkError;
      }
    }else{
      message = messages.applicationError
    }
    dispatch({
      type: actions.AREAS_FAIL,
      payload: message,
    });
  }finally{
    dispatch({
      type: actions.LOADING_AREAS,
      payload: false
    });
  }
}